export enum CountryName {
	Canada = "Canada",
	Switzerland = "Switzerland",
	Spain = "Spain",
	Portugal = "Portugal",
}

export function getTreatmentCodeByCountry(
	treatment:
		| {
				country: { name: string };
				GTIN?: string | null;
				PharmaCode?: string | null;
				SwissmedicNo8?: string | null;
				NDC?: string | null;
				DIN?: string | null;
		  }
		| null
		| undefined
) {
	if (!treatment) {
		return undefined;
	}

	switch (treatment.country.name) {
		case CountryName.Switzerland:
			return treatment.GTIN || treatment.PharmaCode || treatment.SwissmedicNo8;
		case CountryName.Spain:
			return treatment.GTIN || treatment.NDC;
		case CountryName.Canada:
			return treatment.GTIN || treatment.DIN;
		default:
			return treatment.GTIN;
	}
}

export function getTreatmentCodeListByCountry(
	treatment:
		| {
				country: { name: string };
				GTIN?: string | null;
				PharmaCode?: string | null;
				SwissmedicNo8?: string | null;
				NDC?: string | null;
				DIN?: string | null;
		  }
		| null
		| undefined
) {
	if (!treatment) {
		return undefined;
	}

	switch (treatment.country.name) {
		case CountryName.Switzerland:
			return [treatment.GTIN, treatment.PharmaCode, treatment.SwissmedicNo8].filter(Boolean);
		case CountryName.Spain:
			return [treatment.GTIN, treatment.NDC].filter(Boolean);
		case CountryName.Canada:
			return [treatment.GTIN, treatment.DIN].filter(Boolean);
		default:
			return [treatment.GTIN].filter(Boolean);
	}
}
